// ============================================================================
// SYSTÈME DE PRIX DYNAMIQUE - MODAL UNIQUEMENT (VERSION CORRIGÉE)
// ============================================================================

console.log('%c💰 Système de prix dynamique MODAL chargé', 'color: #0F4131; font-weight: bold; font-size: 16px;');

class ModalDynamicPricing {
  constructor() {
    this.init();
  }

  init() {
    const observer = new MutationObserver(() => this.processOpenModals());
    observer.observe(document.body, { childList: true, subtree: true });
    setInterval(() => this.processOpenModals(), 1000);
  }

  processOpenModals() {
    const modals = document.querySelectorAll('quick-view-modal[open], quick-view-modal[active]');
    modals.forEach(modal => {
      // Skip définitivement les modals incompatibles (produit sans paliers)
      if (modal.dataset.pricingInitialized === 'incompatible') return;

      if (!modal.dataset.pricingInitialized) {
        this.initInstance(modal);
      }
      // Si initialisé avec succès, s'assurer que le badge est présent
      if (modal.dataset.pricingInitialized === 'true') {
        this.ensurePriceDisplay(modal);
      }
    });
  }

  initInstance(modal) {
    const radios = modal.querySelectorAll('input[type="radio"]');

    // Pas encore de radios dans le DOM → modal pas prête, on re-tentera au prochain tick
    if (radios.length === 0) return;

    const tiers = this.getTiers(modal);

    // Des radios sont présentes mais aucune ne matche le format palier → produit incompatible
    if (tiers.length === 0) {
      modal.dataset.pricingInitialized = 'incompatible';
      return;
    }

    // Produit compatible ✅
    modal.dataset.pricingInitialized = 'true';
    modal.addEventListener('change', (e) => this.handleGlobalChange(e, modal));
    modal.addEventListener('click', (e) => this.handleGlobalClick(e, modal));
    this.updateLogic(modal, true);
  }

  ensurePriceDisplay(modal) {
    if (!modal.querySelector('.dynamic-price-wrapper-modal')) {
      const qtySelector = modal.querySelector('quantity-input');
      if (qtySelector) {
        const wrapper = document.createElement('div');
        wrapper.className = 'dynamic-price-wrapper-modal';
        wrapper.innerHTML = `<span class="dynamic-price-display-modal">0€</span>`;
        qtySelector.parentNode.insertBefore(wrapper, qtySelector.nextSibling);
        this.updateLogic(modal, false);
      }
    }
  }

  handleGlobalChange(e, modal) {
    if (e.target.name === 'quantity') {
      this.syncQuantityToVariant(modal, parseInt(e.target.value));
    } else if (e.target.type === 'radio') {
      this.updateLogic(modal, true);
    }
  }

  handleGlobalClick(e, modal) {
    const btn = e.target.closest('button');
    if (btn && (btn.name === 'plus' || btn.name === 'minus' || btn.classList.contains('quantity__button'))) {
      setTimeout(() => {
        const qtyInput = modal.querySelector('input[name="quantity"]');
        if (qtyInput) this.syncQuantityToVariant(modal, parseInt(qtyInput.value));
      }, 50);
    }
  }

  syncQuantityToVariant(modal, qty) {
    if (isNaN(qty)) return;
    const tiers = this.getTiers(modal);
    const matchingTier = tiers.find(t => qty >= t.minQty && qty <= t.maxQty);
    const currentRadio = modal.querySelector('input[type="radio"]:checked');

    if (matchingTier && currentRadio && currentRadio.value !== matchingTier.value) {
      matchingTier.radio.click();
    } else {
      this.updateLogic(modal, false);
    }
  }

  updateLogic(modal, isVariantChange) {
    const tiers = this.getTiers(modal);
    const selectedRadio = modal.querySelector('input[type="radio"]:checked');
    const qtyInput = modal.querySelector('input[name="quantity"]');
    const priceDisplay = modal.querySelector('.dynamic-price-display-modal');

    if (!selectedRadio || !qtyInput || !priceDisplay) return;

    const currentTier = tiers.find(t => t.value === selectedRadio.value);
    if (!currentTier) return;

    if (isVariantChange) {
      qtyInput.value = currentTier.minQty;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

      const targetMin = currentTier.minQty;
      [200, 500, 800].forEach(delay => {
        setTimeout(() => {
          if (parseInt(qtyInput.value) !== targetMin && targetMin > 1) {
            qtyInput.value = targetMin;
            this.refreshDisplay(qtyInput.value, currentTier.pricePerUnit, priceDisplay);
          }
        }, delay);
      });
    }

    this.refreshDisplay(qtyInput.value, currentTier.pricePerUnit, priceDisplay);
  }

  getTiers(modal) {
    const radios = modal.querySelectorAll('input[type="radio"]');
    const tiers = [];
    radios.forEach(radio => {
      const title = radio.value;
      const regex1 = /^(\d+)\s*à\s*(\d+)g\s*=\s*(\d+(?:[,.]\d+)?)€\/g$/i;
      const regex2 = /^(\d+)g\s*et\s*\+\s*=\s*(\d+(?:[,.]\d+)?)€\/g$/i;
      let res = title.match(regex1);
      if (res) {
        tiers.push({ minQty: parseInt(res[1]), maxQty: parseInt(res[2]), pricePerUnit: parseFloat(res[3].replace(',', '.')), value: title, radio: radio });
      } else {
        res = title.match(regex2);
        if (res) tiers.push({ minQty: parseInt(res[1]), maxQty: Infinity, pricePerUnit: parseFloat(res[2].replace(',', '.')), value: title, radio: radio });
      }
    });
    return tiers.sort((a, b) => a.minQty - b.minQty);
  }

  refreshDisplay(qty, pricePerUnit, display) {
    const total = (parseInt(qty) || 0) * pricePerUnit;
    display.textContent = `${Math.round(total)}€`;
  }
}

// ============================================================================
// STYLES CSS
// ============================================================================
const styleId = 'modal-pricing-styles-v6';
if (!document.getElementById(styleId)) {
  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    /* Espacement entre quantité et prix */
    quick-view-modal .product-form__quantity { 
      display: flex !important; 
      align-items: center !important; 
      flex-wrap: wrap !important; 
      gap: 30px !important; 
      margin-bottom: 25px !important; 
    }

    /* Mise en blanc des Titres et Textes Gras */
    quick-view-modal h1, quick-view-modal h1 *,
    quick-view-modal h2, quick-view-modal h2 *,
    quick-view-modal h3, quick-view-modal h3 *,
    quick-view-modal b, quick-view-modal strong { 
      color: #FFFFFF !important; 
    }

    /* Badge du prix total */
    .dynamic-price-wrapper-modal { 
      display: inline-flex; 
      align-items: center; 
      justify-content: center; 
      padding: 5px 20px; 
      background: #0F4131; 
      border-radius: 6px; 
      height: 45px; 
      min-width: 100px;
    }

    .dynamic-price-display-modal { 
      color: white !important; 
      font-size: 2rem; 
      font-weight: bold; 
    }

    /* FIX QUANTITÉ : Désactivation du fond "inherit" */
    quick-view-modal .quantity__button:not(:focus-visible):not(.focused), 
    quick-view-modal .quantity__input:not(:focus-visible):not(.focused) {
      background-color: #0F4131 !important;
    }

    quick-view-modal quantity-input { 
      display: flex !important; 
      background: #0F4131 !important; 
      border-radius: 4px; 
      border: 1px solid rgba(255,255,255,0.1) !important;
      overflow: hidden;
    }

    quick-view-modal .quantity__input { 
      color: white !important; 
      -webkit-text-fill-color: white !important; 
      font-weight: bold !important; 
    }

    quick-view-modal .quantity__button { 
      color: white !important; 
      width: 45px !important;
    }
  `;
  document.head.appendChild(style);
}

new ModalDynamicPricing();